var exports = {
  "Tp": "xfd349460--028a26--background",
  "KI": "xfd349460--028a26--icon_container",
  "rV": "xfd349460--028a26--click_area",
  "xd": "xfd349460--028a26--click_area--hidden",
  "q9": "xfd349460--028a26--click_area--left",
};

module.exports = exports;
